module.exports = __webpack_public_path__ + "media/אבד.0e62b817.mp3";